import { render, staticRenderFns } from "./WhyUs.vue?vue&type=template&id=3a1b9ae8&"
import script from "./WhyUs.vue?vue&type=script&lang=js&"
export * from "./WhyUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports